<template>
    <BModal :model-value="modalFilter" title="Technician Filter" centered @update:modelValue="updateModal">
      <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
          <h5 class="">Filter</h5>
          
        </div>
        <BButton
          variant="link"
          class="close"
          @click="updateModal(false)"
        >
          <i class="ion ion-android-close"></i>
        </BButton>
      </template>
      <BForm>
          <div class="form-group">
            <BFormSelect v-model="selectedType" :options="types">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select type</BFormSelectOption>
              </template>
          </BFormSelect>
          </div>
      </BForm>
      <template #footer>
          <div class="d-flex justify-content-end">
              <BButton tton variant="light" @click="submitTechnician" class="mr-2">Reset</BButton>
              <BButton variant="primary" @click="updateModal(false)">Filter</BButton>
          </div>
      </template>
    </BModal>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { 
      BModal, 
      BForm, 
      BFormSelect,
      BFormSelectOption, 
      BButton
  } from "bootstrap-vue-next";
  
  export default {
      name: 'TechnicianFilter',
      components: {
          BModal,
          BFormSelect,
          BFormSelectOption, 
          BButton,
          BForm
      },
      props: {
          modalFilter: Boolean,
      },
      setup(props, {emit}){
        const selectedType = ref('')
        const types = ref([
          {
            value: '',
            text: 'All'
          },
          {
            value: 'internal',
            text: 'Internal'
          },
          {
            value: 'vendor',
            text: 'Vendor'
          }
        ])
        const updateModal = (value) => {
              emit("filter-data", selectedType.value)
              emit("update:modalFilter", value);
          };
        return{
            updateModal,
            types,
            selectedType,
        }
    }
  }
  </script>
  
  <style>
  
  </style>